import { render } from "./TabbedBodyLayout.vue?vue&type=template&id=a041e01a&scoped=true"
import script from "./TabbedBodyLayout.vue?vue&type=script&lang=js"
export * from "./TabbedBodyLayout.vue?vue&type=script&lang=js"

import "./TabbedBodyLayout.vue?vue&type=style&index=0&id=a041e01a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a041e01a"

export default script